module.exports = __webpack_public_path__ + "fonts/Lato-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Lato/Lato-Regular.ttf
// module id = 3433
// module chunks = 0